var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ConstantSelector } from '../constant-selector.component';
var IconSelectComponent = /** @class */ (function (_super) {
    __extends(IconSelectComponent, _super);
    function IconSelectComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._defaultOptions = [
            'ca-accessibility',
            'ca-face',
            'ca-person-stalker',
            'ca-home',
            'ca-wc',
            'ca-restaurant_menu',
            'ca-work',
            'ca-content_paste',
            'ca-priority-severe',
            'ca-timer',
            'ca-thumbs-up',
            'ca-thumbs-down',
            'ca-nature_people',
            'ca-bath',
            'ca-shield',
            'ca-file-text-o',
            'ca-medkit',
            'ca-school',
            'ca-local_florist',
            'ca-local_taxi',
            'ca-healing',
            'ca-airport_shuttle'
        ];
        _this.options = _this._defaultOptions;
        return _this;
    }
    return IconSelectComponent;
}(ConstantSelector));
export { IconSelectComponent };
